'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _MemoryStorage = require('./Storage/MemoryStorage');

var _MemoryStorage2 = _interopRequireDefault(_MemoryStorage);

var _FileLoader = require('../loader/FileLoader');

var _FileLoader2 = _interopRequireDefault(_FileLoader);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Model = function () {
  function Model(storage, _loaders) {
    _classCallCheck(this, Model);

    this.storage = storage ? storage : new _MemoryStorage2.default();
    var loaders = _loaders ? Array.isArray(_loaders) ? _loaders : [_loaders] : [new _FileLoader2.default()];
    this.loaders = loaders.filter(Boolean);
  }

  /**
   * get text from storage, if storage didn't have one, try to load it.
   *
   * @param {string} scope
   * @param {LocaleOption} option
   * @param {Array<LoaderInterface>} [loaders=this.loaders]
   * @returns {Promise<string>}
   * @memberof Model
   */


  _createClass(Model, [{
    key: 'loadText',
    value: function loadText(scope) {
      var _this = this;

      var _option = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      var loaders = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : this.loaders;

      var activeLanguage = this.storage.getActiveLocale && this.storage.getActiveLocale();
      var option = _option.language ? _option : _extends({}, _option, {
        language: activeLanguage
      });
      if (this.storage.hasText(scope, option)) {
        return Promise.resolve(this.getText(scope, option));
      }
      if (loaders.length) {
        return loaders[0].load(scope, option).then(function (value) {
          if (value) {
            return _this.storage.setText(scope, value, option);
          }
          console.warn(_typeof(loaders[0]) + ' didn\'t have ' + scope);
          return _this.loadText(scope, option, loaders.slice(1));
        }).catch(function (e) {
          console.warn(_typeof(loaders[0]) + ' didn\'t have ' + scope + ': ' + e);
          return _this.loadText(scope, option, loaders.slice(1));
        });
      }
      return Promise.resolve(scope);
    }
  }, {
    key: 'getText',
    value: function getText(scope, option) {
      var result = this.storage.getText(scope, option);
      if (result) return result;
      return scope;
    }
  }, {
    key: 'setText',
    value: function setText(scope, value) {
      var option = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

      return this.storage.setText(scope, value, option);
    }
  }, {
    key: 'setActiveLocale',
    value: function setActiveLocale(activeLocale) {
      return this.storage.setActiveLocale(activeLocale);
    }
  }, {
    key: 'getActiveLocale',
    value: function getActiveLocale() {
      return this.storage.getActiveLocale();
    }
  }, {
    key: 'addLanguageScope',
    value: function addLanguageScope(language, textByScope) {
      this.storage.addLanguageScope(language, textByScope);
      return this;
    }
  }]);

  return Model;
}();

exports.default = Model;
module.exports = exports['default'];